import { createI18n, useI18n } from 'vue-i18n'
import nn from '~/translations/nn'
import nb from '~/translations/nb'

const messages = {
  nb,
  nn,
}

const options = {
  legacy: false,
  locale: 'nb',
  fallbackLocale: 'nb',
  warnHtmlMessage: false,
  messages,
}

const i18n = createI18n(options)
const simpleI18n = () => useI18n(options)

export {
  messages,
  i18n,
  simpleI18n,
}
